<div class="sam-margin sam-email-window-close-dialog">
   <div class="title sam-float-left">
      {{ 'samwin.email_dialog.close_dialog.title' | translate }}
   </div>
   <div class="sam-full-width">
      <button kendoButton [primary]="true" (click)="onComplete()" class="sam-margin-right sam-float-left">
         {{ 'messages_actions.complete' | translate }}
      </button>
      <button
         kendoButton
         [disabled]="!(isFeatureEnabled$ | async)"
         [primary]="true"
         (click)="onReassign()"
         class="sam-float-left"
      >
         {{ 'messages_actions.reassign' | translate }}
      </button>
      <button kendoButton (click)="onCancel()" class="sam-float-right">{{ 'common.cancel' | translate }}</button>
   </div>
</div>
